import { createStore } from "vuex";

import modules from "./modules";

const store = createStore({
  state() {
    return {
      email: null,
      isAnswer: false,
      message: null,
      isNewThread: false,
      isForward: false,
      isEdit: false,
      isDraft: false,
      mailboxes: [],
    };
  },

  getters: {
    email: (state) => {
      return state.email;
    },
    isAnswer: (state) => {
      return state.isAnswer;
    },
    message: (state) => {
      return state.message;
    },

    isNewThread: (state) => {
      return state.isNewThread;
    },
    isForward: (state) => {
      return state.isForward;
    },
    isEdit: (state) => {
      return state.isEdit;
    },
    isDraft: (state) => {
      return state.isDraft;
    },
    mailboxes: (state) => {
      return state.mailboxes;
    },
  },
  mutations: {
    setEmail(state, email) {
      state.email = email;
      //window.localStorage.setItem("mailbox", email.email);
    },
    setMailboxes(state, mailboxes) {
      state.mailboxes = mailboxes;
    },
    setAnswer(state, message) {
      state.isAnswer = true;
      state.message = message;
    },
    setNewThread(state, message) {
      state.isNewThread = true;
      state.message = message;
    },
    setForward(state, message) {
      state.isForward = true;
      state.message = message;
    },
    setEdit(state, message) {
      state.isEdit = true;
      state.message = message;
    },
    setDraft(state, message) {
      state.isDraft = true;
      state.message = message;
    },
    resetSelection(state) {
      state.isAnswer = false;
      state.isNewThread = false;
      state.isForward = false;
      state.isEdit = false;
      state.isDraft = false;
      state.message = null;
    },
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== "production",
});

export default store;
